import type {PopupAnchorRect} from '@Components/poster-editor/components/poster-popup-menu/poster-popup-menu.types';
import type {FabricObjectPositionOrDimensionKeys} from '@Components/poster-editor/components/custom-item-controls/custom-item-controls.types';

export const CUSTOM_ITEM_ACTION_BAR_ID = 'custom-item-action-bar';
/** The image Replace button keeps this id: the image replace popup ignores outside-clicks that land on it, so the button toggles the popup. */
export const CUSTOM_REPLACE_CONTROL_ID = 'custom-replace-control';

/** Gap between the bottom of the selection (or the rotation handle, when the item is turned upside down) and the bar. */
export const ITEM_ACTION_BAR_MARGIN = 16;

/** The rotation handle hangs this far beyond the item's top edge, measured to the far side of the handle. */
export const ROTATION_HANDLE_REACH = 45;

/** Clicked button, sent as the `action` param of `Editor_Action_Bar_Clicked`. More is counted by `Editor_Item_Menu_Opened` instead. */
export enum ItemActionBarAction {
  REPLACE = 'replace',
  EDIT = 'edit',
  GROUP = 'group',
  UNGROUP = 'ungroup',
  PREVIOUS_SLIDE = 'previous_slide',
  NEXT_SLIDE = 'next_slide',
  DUPLICATE = 'duplicate',
  DELETE = 'delete',
}

/** An item-specific button shown before Duplicate and Delete (Replace for images, Edit for tables and menus, previous/next slide for slideshows, Group/Ungroup for multi-selections). */
export interface ItemActionBarLeadingAction {
  action: ItemActionBarAction;
  id: string;
  icon: string;
  ariaLabel: string;
  isDisabled: boolean;
  /** Drawn pressed, while the menu this button opened is showing. */
  isSelected: boolean;
  /** `anchorRect` is the clicked button's spot on the bar, for a button that opens a menu next to it. */
  onClick(anchorRect: PopupAnchorRect): void;
}

export interface ItemActionBarAnchor {
  /** Horizontal centre of the bar, in the controls wrapper's pixels. */
  centerX: number;
  top: number;
}

export interface ItemActionBarProps {
  pageHashedId: string;
  positionProperties: FabricObjectPositionOrDimensionKeys;
}
